import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
// components
import Field from 'components/Field';
import Button from 'components/Button';
// translate
import { FormattedMessage } from 'react-intl';

const AminoForm = (props) => {
  const {
    change,
    passwordHint,
    handleForm,
    resetForm,
    handleSubmit,
    pristine,
    submitting,
    formValues,
  } = props;
  const isSubmitDisabled = pristine || submitting || !formValues.username.trim();
  const onSubmit = (data) => handleForm(data, change);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="mb-20">
      <Field
        placeholderKey="general.typeUsername"
        label={<FormattedMessage id="general.username" />}
        name="username"
      />

      <Field
        placeholderKey={!passwordHint ? 'general.typePassword' : ''}
        placeholder={passwordHint}
        label={<FormattedMessage id="general.password" />}
        name="password"
      />

      <div className="mt-10 text-right">
        <Button type="reset" light className="mr-10 wider" onClick={resetForm}>
          <FormattedMessage id="general.button.reset" />
        </Button>
        <Button type="submit" primary className="wider" disabled={isSubmitDisabled}>
          <FormattedMessage id="general.button.submit" />
        </Button>
      </div>
    </form>
  );
};

AminoForm.propTypes = {
  change: T.func.isRequired,
  handleForm: T.func.isRequired,
  resetForm: T.func.isRequired,
  handleSubmit: T.func.isRequired,
  passwordHint: T.string,
  formValues: T.object,
  pristine: T.bool.isRequired,
  submitting: T.bool.isRequired,
};

const formComponent = reduxForm({
  form: 'amino-form',
  enableReinitialize: true,
})(AminoForm);

export default connect(
  (state) => ({
    formValues: getFormValues('amino-form')(state),
  }), {}
)(formComponent);
